<template>
  <div class="expenseStatistics">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <div class="custom-date">
            <div class="date-btn1" @click="onShowEmit('expenseStatisticsCategory')">
              <span v-if="searchForm.ECName">{{ searchForm.ECName }}</span>
              <span v-else>{{ $t.expenseStatistics.project }}</span>
            </div>
            <div class="date-btn2" @click="showYearDate">
              <span v-if="searchForm.Year">{{ searchForm.Year }} {{ $t.meta.year }}</span>
              <span v-else>{{ $t.expenseStatistics.year }}</span>
            </div>
            <van-button size="small" type="info" @click="onSearch">{{
              $t.meta.search
            }}</van-button>
          </div>
        </van-col>
      </van-row>
    </div>

    <template v-if="categoryList.length > 0">
      <van-form>
        <ve-pie :data="chartData"></ve-pie>

        <div class="expenseStatistics-radio">
          <div class="radio-label">
            {{ $t.expenseStatistics.totalCost }}：{{ totalCost }}
          </div>
          <div class="radio-value" v-for="(item, index) in chartData.rows" :key="index">
            {{ item.type }} : {{ currencySn }} {{ item.value }}
          </div>
        </div>

        <ve-histogram :data="monthData" :settings="chartSettings"></ve-histogram>
      </van-form>

      <div class="searchTop">
        <van-row type="flex" align="center" class="search-top-row">
          <van-col class="colItem1">
            <div class="custom-date">
              <div class="date-btn1" @click="onShowEmit('expenseStatisticsParent')">
                <span v-if="searchForm.ParentCategoryName">{{
                  searchForm.ParentCategoryName
                }}</span>
                <span v-else style="color: #969799">{{
                  $t.expenseStatistics.parentName
                }}</span>
              </div>
              <div class="date-btn2" @click="onShowEmit('expenseStatisticsChild')">
                <span v-if="searchForm.SubCategoryName">{{
                  searchForm.SubCategoryName
                }}</span>
                <span v-else style="color: #969799">{{
                  $t.expenseStatistics.subName
                }}</span>
              </div>
              <van-button size="small" type="info" @click="getList">{{
                $t.meta.search
              }}</van-button>
            </div>
          </van-col>
        </van-row>
      </div>

      <van-list
        class="list"
        v-model="loading"
        :finished="finished"
        :finished-text="$t.meta.noMore"
        :error.sync="error"
        :error-text="errorText"
      >
        <div
          class="list-container"
          v-for="(item, index) in tableData"
          :key="index"
          @click="gotoDetail(item.SubCategoryId)"
        >
          <div class="list-item">
            {{ $t.expenseStatistics.itemName }}：{{ item.CategoryName }}
          </div>
          <div class="list-item">
            {{ $t.expenseStatistics.parentName }}：{{ item.ParentCategoryName }}
          </div>
          <div class="list-item">
            {{ $t.expenseStatistics.subName }}：{{ item.SubCategoryName }}
          </div>
          <div class="list-item">
            {{ $t.expenseStatistics.amount }}：{{ item.TotalAmount }}
          </div>
          <div class="list-item">
            {{ $t.expenseStatistics.currencySn }}：{{ item.CurrencySn }}
          </div>
          <div class="list-item">
            {{ $t.expenseStatistics.parentNameProportion }}：{{
              item.CategoryExpenditureProportion
            }}
          </div>
          <div class="list-table">
            <div class="month-label">{{ $t.expenseStatistics.monthTitle }}：</div>
            <div
              class="month-values"
              v-for="(month, index) in item.MonthExpenditureAmountList"
              :key="index"
            >
              {{ $t.expenseStatistics["month" + month.key] }} :
              {{ month.value }}
            </div>
          </div>
        </div>
      </van-list>
    </template>
    <div v-else class="unload">
      <div class="unload-text">
        {{ $t.expenseStatistics.project }} {{ $t.meta.noData }}
      </div>
      <van-button size="small" @click="gotoExpenseCategory">{{
        $t.meta.goToCreate
      }}</van-button>
    </div>

    <van-popup v-model="showYearPicker" position="bottom">
      <van-datetime-picker
        type="year-month"
        :title="$t.expenseStatistics.selectYear"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showYearPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <option-list
      event="expenseStatisticsCategory"
      :options="categoryList"
      @onSelect="onSelectCateogry"
    ></option-list>

    <option-list
      event="expenseStatisticsParent"
      :options="parentCategoryList"
      @onSelect="onSelectParent"
    ></option-list>

    <option-list
      event="expenseStatisticsChild"
      :options="subCategoryList"
      @onSelect="onSelectChild"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import OptionList from "@components/optionList/OptionList.vue";
import {
  List,
  Form,
  Field,
  Button,
  Uploader,
  Icon,
  Row,
  Col,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";

Vue.use(List)
  .use(Form)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Icon)
  .use(Row)
  .use(Col)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "expenseStatistics",
  components: {
    OptionList,
  },
  data() {
    return {
      searchForm: {
        CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
        Year: "",
        ECId: null,
        ECName: "",
        ParentCategoryId: "",
        ParentCategoryName: "",
        SubCategoryId: "",
        SubCategoryName: "",
      },
      totalCost: "",
      currencySn: "",
      tableData: [],
      categoryList: [],
      parentCategoryList: [],
      subCategoryList: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //日期
      selectDate: new Date(),
      currentDate: "",
      showYearPicker: false,
      chartData: null,
      monthData: null,
      chartSettings: {
        yAxisType: ["KMB", "percent"],
        labelMap: { value: this.$t.expenseStatistics.monthTotal },
      },
    };
  },
  created() {
    this.initChartData();
    this.defaultDate();
    this.firstLoad(true, false);
  },
  methods: {
    gotoExpenseCategory() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "expenseCategorySettings",
        name: "expenseCategorySettings",
        query: [],
      });
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "expenseStatisticsDetail",
        name: "expenseStatisticsDetail",
        query: [
          {
            name: "SubCategoryId",
            value: id,
          },
          {
            name: "Year",
            value: this.searchForm.Year,
          },
        ],
      });
    },
    initChartData() {
      this.chartData = {
        columns: ["type", "value"],
        rows: [],
      };
      this.monthData = {
        columns: ["type", "value"],
        rows: [],
      };
    },
    firstLoad(isDefault = false, isDetail = false) {
      this.getExpenseCategoryList().then((success) => {
        if (success) {
          if (this.categoryList.length > 0) {
            if (isDefault) {
              this.onSelectCateogry(this.categoryList[0]);
            }
            if (isDetail) {
              var cate = this.categoryList.find((p) => p.value == this.searchForm.ECId);
              if (cate) {
                this.searchForm.ECName = cate.text;
              }
            }
            this.costCategoryStatistics();
          }
        }
      });
    },
    onSearch() {
      this.initChartData();
      this.firstLoad(false, false);
    },
    showYearDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showYearPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        return year;
      };
      this.searchForm.Year = formatDate(date);
      this.showYearPicker = false;
    },
    defaultDate() {
      let date = new Date();
      this.searchForm.Year = date.getFullYear().toString();
    },
    costCategoryStatistics() {
      this.$commonMethod.showLoading();
      var param = this.searchForm;
      this.$api.dataSummary
        .costCategoryStatistics(param)
        .then((res) => {
          var data = res.data;
          this.totalCost = data.TotalCost;
          this.currencySn = data.CurrencySn;
          //图表
          var rows = [];
          for (var item of data.DetailList) {
            rows.push({
              type: item.CategoryName,
              value: item.TotalExpenses,
            });
          }
          this.chartData.rows = rows;
          this.getList();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.loading = false;
          this.error = false;
          this.errorText = "";
          this.finished = true;
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];

      var param = this.searchForm;
      this.$api.dataSummary
        .getCostCategoryDetailList(param)
        .then((res) => {
          this.tableData = res.data;
          this.getMonthTotal(this.tableData);
          this.loading = false;
          this.error = false;
          this.errorText = "";
          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getMonthTotal(items) {
      var selectionList = [];
      if (this.tableData.length > 0) {
        var C1 = {
          type: this.$t.expenseStatistics.month1,
          value: 0,
        };
        var C2 = {
          type: this.$t.expenseStatistics.month2,
          value: 0,
        };
        var C3 = {
          type: this.$t.expenseStatistics.month3,
          value: 0,
        };
        var C4 = {
          type: this.$t.expenseStatistics.month4,
          value: 0,
        };
        var C5 = {
          type: this.$t.expenseStatistics.month5,
          value: 0,
        };
        var C6 = {
          type: this.$t.expenseStatistics.month6,
          value: 0,
        };
        var C7 = {
          type: this.$t.expenseStatistics.month7,
          value: 0,
        };
        var C8 = {
          type: this.$t.expenseStatistics.month8,
          value: 0,
        };
        var C9 = {
          type: this.$t.expenseStatistics.month9,
          value: 0,
        };
        var C10 = {
          type: this.$t.expenseStatistics.month10,
          value: 0,
        };
        var C11 = {
          type: this.$t.expenseStatistics.month11,
          value: 0,
        };
        var C12 = {
          type: this.$t.expenseStatistics.month12,
          value: 0,
        };

        for (var item of items) {
          var test = Object.entries(item.MonthExpenditureAmountDic);
          var array = test.map(([key, value]) => ({
            key,
            value,
          }));
          item.MonthExpenditureAmountList = array;
          for (var month of item.MonthExpenditureAmountList) {
            if (month.key == 1) {
              C1.value = C1.value + month.value;
            }
            if (month.key == 2) {
              C2.value = C2.value + month.value;
            }
            if (month.key == 3) {
              C3.value = C3.value + month.value;
            }
            if (month.key == 4) {
              C4.value = C4.value + month.value;
            }
            if (month.key == 5) {
              C5.value = C5.value + month.value;
            }
            if (month.key == 6) {
              C6.value = C6.value + month.value;
            }
            if (month.key == 7) {
              C7.value = C7.value + month.value;
            }
            if (month.key == 8) {
              C8.value = C8.value + month.value;
            }
            if (month.key == 9) {
              C9.value = C9.value + month.value;
            }
            if (month.key == 10) {
              C10.value = C10.value + month.value;
            }
            if (month.key == 11) {
              C11.value = C11.value + month.value;
            }
            if (month.key == 12) {
              C12.value = C12.value + month.value;
            }
          }
        }
        C1.value = C1.value.toFixed(2);
        C2.value = C2.value.toFixed(2);
        C3.value = C3.value.toFixed(2);
        C4.value = C4.value.toFixed(2);
        C5.value = C5.value.toFixed(2);
        C6.value = C6.value.toFixed(2);
        C7.value = C7.value.toFixed(2);
        C8.value = C8.value.toFixed(2);
        C9.value = C9.value.toFixed(2);
        C10.value = C10.value.toFixed(2);
        C11.value = C11.value.toFixed(2);
        C12.value = C12.value.toFixed(2);
        selectionList.push(C1);
        selectionList.push(C2);
        selectionList.push(C3);
        selectionList.push(C4);
        selectionList.push(C5);
        selectionList.push(C6);
        selectionList.push(C7);
        selectionList.push(C8);
        selectionList.push(C9);
        selectionList.push(C10);
        selectionList.push(C11);
        selectionList.push(C12);
        this.monthData.rows = selectionList;
      } else {
        this.monthData.rows = [];
      }
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSelectCateogry(item) {
      this.searchForm.ECName = item.text;
      this.searchForm.ECId = item.value;
    },
    onSelectParent(item) {
      this.searchForm.ParentCategoryName = item.text;
      this.searchForm.ParentCategoryId = item.value;
      this.getSubCategoryList();
    },
    onSelectChild(item) {
      this.searchForm.SubCategoryName = item.text;
      this.searchForm.SubCategoryId = item.value;
    },
    getSubCategoryList() {
      this.searchForm.SubCategoryName = "";
      this.searchForm.SubCategoryId = null;
      this.subCategoryList = [];
      for (const parent of this.parentCategoryList) {
        if (parent.value == this.searchForm.ParentCategoryId) {
          this.subCategoryList = parent.options;
          break;
        } else {
          this.subCategoryList = [];
        }
      }
    },
    getExpenseCategoryList() {
      return new Promise((resolve) => {
        this.$api.systemManagement
          .getExpenseCategoryList()
          .then((res) => {
            var categoryList = [];
            var parentCategoryList = [];
            res.data.forEach((category) => {
              var data1 = {
                text: category.CategoryName,
                value: category.ECId,
              };
              category.ExpenseSubCategory.forEach((parent) => {
                var data2 = {
                  text: parent.CategoryName,
                  value: parent.ECId,
                  options: [],
                };
                parent.ExpenseSubCategory.forEach((child) => {
                  data2.options.push({
                    text: child.CategoryName,
                    value: child.ECId,
                  });
                });
                parentCategoryList.push(data2);
              });
              categoryList.push(data1);
            });
            this.categoryList = categoryList;
            this.parentCategoryList = parentCategoryList;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.expenseStatistics {
  ::v-deep .van-popup {
    .van-picker__columns {
      .van-picker-column:nth-of-type(2) {
        display: none !important;
      }
    }
  }
  .unload {
    text-align: center;
    padding: 50px;
    .unload-text {
      font-size: 14px;
      color: #969799;
      margin-bottom: 30px;
    }
    .van-button__text {
      font-size: 14px !important;
    }
  }
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          .van-cell {
            padding: 5px 8px 5px 0;
          }
        }
        .van-cell {
          padding: 10px 0px 10px 20px;
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
            width: 18%;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }
  .van-form {
    .ve-pie {
      padding-top: 20px;
    }
    .ve-histogram {
      padding-top: 20px;
      border-bottom: 1px solid #ebedf0;
    }
    .expenseStatistics-radio {
      padding-top: 0px;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #ebedf0;
      .radio-label {
        color: #000;
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: bold;
      }
      .radio-value {
        margin-bottom: 10px;
        font-size: 12px;
        color: #646566;
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
        width: 50%;
        display: inline-block;
      }
      .list-item:nth-last-child(2) {
        margin-bottom: 0px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .list-table {
        .month-label {
          color: #333;
        }
        .month-values {
          color: #999;
          margin-top: 10px;
          width: 25%;
          display: inline-block;
        }
      }
      .buttons {
        text-align: right;
        padding-bottom: 10px;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
}
</style>
